import { render, staticRenderFns } from "./detail_mindset_page.vue?vue&type=template&id=ebdec27c&scoped=true"
import script from "./detail_mindset_page.vue?vue&type=script&lang=js"
export * from "./detail_mindset_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebdec27c",
  null
  
)

export default component.exports